import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import PaymentGatewayComp from "../components/PaymentGatewayComp";
import "../PG-CSS/paymentGateway.css";
import { startPaymentSession, UPDATE_STRIPE } from "../actions/paymentGateway";
import { fetchMutation } from "../../../actions";
import CircleLoader from "../../notes/component/CircleLoader";
import WithLayout from "../../trialUsers/container/wrapperLogo";

const StripePaymentGatewayCont = (props) => {
   const { history, isTrialUser, extendTrial, trialRemaining, subscription_interval } = props;
   const [loading, setLoading] = useState(false);
   const [fromStartSubscription, setFromStartSubscription] = useState(false);
   const [isNeedMoreTime, setIsNeedMoreTime] = useState(false);
   const [step, setStep] = useState(null);

   const createStripePayment = () => {
      localStorage.setItem("showTrialButton", "true");
      startPaymentSession(subscription_interval);
   };

   useEffect(() => {
      if (isTrialUser !== undefined && extendTrial !== undefined && trialRemaining !== undefined) {
         const determineStepFun = () => {
            const searchParams = new URLSearchParams(window.location.search || "");
            const isFinal = searchParams?.get("isFinal") === "true";
            if (isFinal) {
               return 4;
            }
            if (isTrialUser) {
               if (!extendTrial) return trialRemaining > 0 ? 2 : 3;
               return 4;
            }
            return 2; // Default step for non-trial users
         };
         setStep(determineStepFun());
      }
   }, [isTrialUser, extendTrial, trialRemaining]);

   const updateStripeStatus = () => {
      localStorage.setItem("trialEndedRedirection", "true");
      setLoading(true);
      const stripeObj = {
         user: {
            extendTrial: true,
         },
      };
      fetchMutation(
         UPDATE_STRIPE,
         stripeObj,
         () => {
            setLoading(false);
            history.push("/notes");
         },
         (error) => {
            setLoading(false);
            console.error("Error updating Stripe status:", error);
         }
      );
   };

   // Show loader while waiting for props or step calculation
   if (step === null) {
      return <CircleLoader />;
   }

   return (
      <WithLayout showNeedHelp={step === 1} removeMargin={true}>
         <PaymentGatewayComp
            step={step}
            setStep={setStep}
            loading={loading}
            updateStripeStatus={updateStripeStatus}
            createStripePayment={createStripePayment}
            isNeedMoreTime={isNeedMoreTime}
            setIsNeedMoreTime={setIsNeedMoreTime}
            fromStartSubscription={fromStartSubscription}
            setFromStartSubscription={setFromStartSubscription}
            {...props}
         />
      </WithLayout>
   );
};

const mapStateToProps = (state) => ({
   extendTrial: state?.auth?.loggedInProviderDetails?.extendTrial,
   isSubscribed: state?.auth?.loggedInProviderDetails?.isSubscribed,
   isTrialUser: state?.auth?.loggedInProviderDetails?.isTrialUser,
   trialRemaining: state?.auth?.loggedInProviderDetails?.trialRemaining,
   subscription_interval: state?.auth?.subscriptionInterval,
});

export default withRouter(connect(mapStateToProps)(StripePaymentGatewayCont));
